import b from 'b_';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './progress-line.scss';

const ProgressLine = ({ fail = 0, mix, success, unevaluated = 0, unknown }) => {
    const total = success + fail + unknown + unevaluated;

    const correctPart = (success / total) * 100;
    const incorrectPart = (fail / total) * 100;
    const unknownPart = unknown && 100 - (correctPart + incorrectPart);
    const unevaluatedPart = (unevaluated / total) * 100;

    const successClass = b('progress-line', 'stripe', { success: true });
    const unknownClass = b('progress-line', 'stripe', { unknown: true });
    const failClass = b('progress-line', 'stripe', { fail: true });
    const unevaluatedClass = b('progress-line', 'stripe', { unevaluated: true });

    return (
        <div className={cx('progress-line', mix)}>
            <div className="progress-line__inner-wrapper">
                {!!correctPart && <span className={successClass} style={{ width: `${correctPart}%` }} />}
                {!!unevaluatedPart && <span className={unevaluatedClass} style={{ width: `${unevaluatedPart}%` }} />}
                {!!unknownPart && <span className={unknownClass} style={{ width: `${unknownPart}%` }} />}
                {!!incorrectPart && <span className={failClass} style={{ width: `${incorrectPart}%` }} />}
            </div>
        </div>
    );
};

ProgressLine.propTypes = {
    fail: PropTypes.number,
    mix: PropTypes.string,
    success: PropTypes.number.isRequired,
    unevaluated: PropTypes.number,
    unknown: PropTypes.number.isRequired,
};

export default ProgressLine;
